import { AspectRatio, Box, SimpleGrid } from '@chakra-ui/react';
import { RecommendedBadge } from '@time-line/components/common';
import { ProductBadgeContained } from 'components/product/ProductBadge/ProductBadgeContained';
import type { ReactNode } from 'react';
import type { ProductBullet } from 'types/cms/ProductBullet';

export interface ProductCardImageWrapperProps {
  productBullet?: ProductBullet;
  isPreorder?: boolean;
  isDoctorRecommended: boolean;
  children?: ReactNode;
  ratio?: number;
  availableForSale?: boolean;
}

export const ProductCardImageWrapper = ({
  isPreorder,
  isDoctorRecommended,
  productBullet,
  availableForSale,
  ratio,
  children,
}: ProductCardImageWrapperProps) => (
  <AspectRatio ratio={ratio}>
    <Box
      sx={{
        containerType: 'inline-size',
      }}
    >
      <SimpleGrid
        columns={1}
        width="100%"
        bgColor="gray.100"
        borderRadius="base"
        overflow="hidden"
      >
        <ProductBadgeContained
          className="product_badge"
          gridColumn={1}
          gridRow={1}
          zIndex={1}
          justifySelf="left"
          alignSelf="top"
          transitionProperty="common"
          transitionDuration="slow"
          availableForSale={availableForSale}
          productBullet={productBullet}
          isPreorder={isPreorder}
          sx={{
            '@media(hover: hover) and (pointer: fine)': {
              _groupHover: {
                opacity: 0,
              },
            },
          }}
        />

        {children}

        {isDoctorRecommended && (
          <Box
            gridColumn={1}
            gridRow={1}
            zIndex={1}
            justifySelf="center"
            alignSelf="end"
            mb="sm"
            sx={{
              '@media(hover: hover) and (pointer: fine)': {
                _groupHover: {
                  opacity: 0,
                },
              },
            }}
            transitionProperty="common"
            transitionDuration="slow"
            display={{ base: 'none', sm: 'block' }}
          >
            <RecommendedBadge size="sm" />
          </Box>
        )}
      </SimpleGrid>
    </Box>
  </AspectRatio>
);
